var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('v-table',{attrs:{"url":"/api/v1/cache","attributes":[
        {
          attribute: 'title',
          name: 'Cache'
        },
        {
          attribute: 'cache',
          name: 'Update',
          type: 'UpdateCell',
          label: 'Update'
        }
      ]}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Cache Update")])])
}]

export { render, staticRenderFns }